<template>
  <div id="app">

        <b-row class="text-center">
          <b-col sm="12">
            <b-img src="http://www.hcdrauch.com.ar/inscripcion/imagenes/logoTurnosInspeccion.jpg"  fluid alt="Responsive image"></b-img>
          </b-col>
        </b-row>

        <b-row align-v="center" align-h="center">
            <b-form-datepicker 
              id="datepicker-valid" 
              v-model="FechaElegida"
              min="2021-05-01"
              @input="Cargar_tabla_turnos()"
              :max="f_salida"
              :state="estadoFechaE"
              :date-disabled-fn="dateDisabled"
              placeholder="Elija una Fecha"
              style="width:320px">
            </b-form-datepicker>
        </b-row>

        <b-row align-v="center" align-h="center" :hidden="siEsViernes">
          <label>Apellido y nombre:</label>          
          <b-form-input 
            v-model="apyno1"
            placeholder="Ingrese Apellido y Nombre"
            :state="validarapyno1"
            style="width:300px"> 
          </b-form-input>
        </b-row>

        <b-row align-v="center" align-h="center" :hidden="siEsViernes">
          <label>Número DNI:</label>          
          <b-form-input 
            v-model="DNI1"
            :state="validarDNI1"
            placeholder="Ingrese N° DNI"
            style="width:150px"> 
          </b-form-input>
        </b-row>

        <b-row align-v="center" align-h="center" :hidden="siEsViernes">
          <label>Número de teléfono:</label>
          <b-form-input 
            v-model="Telefono1"
            :state="validarTelefono1"
            style="width:150px"> 
          </b-form-input>
        </b-row>    

        <b-row align-v="center" align-h="center" :hidden="siEsViernes">
          <label>Mail:</label>
          <b-form-input 
            v-model="Mail1"
            type="email"
            :state="validarMail1"
            style="width:270px"> 
          </b-form-input>
        </b-row>

        <b-row align-v="center" align-h="center" :hidden="validarHorario1">
            <label>Seleccione horario disponible:</label>
              <b-form-select
                id="horario"
                v-model="HorarioElegido"
                :options="array_turnos"
                value-field="id"
                text-field="fecha"
                disabled-field="notEnabled"
                :state="validarHorario"
                style="width:120px"
                ><!-- :state="estadoHorario"  @change="ClickHorarioSeleccionado()"-->
              ></b-form-select> 
        </b-row> 

        <b-row align-v="center" align-h="center" :hidden="validarReservaTurno1">
          <b-button 
            variant="success" 
            @click="reservarTurno1()"
            style="width:270px">
            Reservar el Turno
          </b-button>
        </b-row> 

        <b-row align-v="center" align-h="center" :hidden="siNoEsViernes">
          <label>Número DNI:</label>          
          <b-form-input 
            v-model="DNI"
            placeholder="Ingrese N° DNI"
            style="width:150px"> 
          </b-form-input>
          <b-button 
            variant="success" 
            @click="buscarPorNumero()">
            Buscar
          </b-button>
        </b-row>

        <b-row align-v="center" align-h="center" :hidden="estadoPersona">
          Nombre: {{nombrePersona}}
        </b-row>

        <b-row align-v="center" align-h="center" :hidden="estadoPersona">
          <label>Número de teléfono:</label>
          <b-form-input 
            v-model="Telefono"
            :state="validarTelefono"
            style="width:150px"> 
          </b-form-input>
        </b-row>

        <b-row align-v="center" align-h="center" :hidden="estadoPersona">
          <label>Mail:</label>
          <b-form-input 
            v-model="Mail"
            type="email"
            :state="validarMail"
            style="width:270px"> 
          </b-form-input>
        </b-row> 

        <b-row align-v="center" align-h="center" :hidden="estadoPersona">
            <label>Seleccione horario disponible:</label>
              <b-form-select
                id="horario"
                v-model="HorarioElegido"
                :options="array_turnos"
                value-field="id"
                text-field="fecha"
                disabled-field="notEnabled"
                :state="validarHorario"
                style="width:120px"
                ><!-- :state="estadoHorario"  @change="ClickHorarioSeleccionado()"-->
              ></b-form-select> 
        </b-row>
      
        <b-row align-v="center" align-h="center" :hidden="validarReservaTurno">
          <b-button 
            variant="success" 
            @click="reservarTurno()"
            style="width:270px">
            Reservar el Turno
          </b-button>
        </b-row> 

        <b-modal ref="my-modal" hide-footer >
          <template #modal-header="{ close }">
            <b-img src="http://www.hcdrauch.com.ar/inscripcion/imagenes/logoTurnosInspeccion.jpg"  fluid alt="Responsive image"></b-img>
          </template>
          <div class="d-block text-center">
            <h5>Su turno ha sido reservado</h5>
          </div>
        </b-modal>

        <b-modal ref="my-modal-no" hide-footer >
          <template #modal-header="{ close }">
            <b-img src="http://www.hcdrauch.com.ar/inscripcion/imagenes/logoTurnosInspeccion.jpg"  fluid alt="Responsive image"></b-img>
          </template>
          <div class="d-block text-center">
            <h3>Su turno NO ha sido reservado</h3>
            <h5>Por favor seleccione otro horario</h5>
          </div>
        </b-modal>
        <!-- src: '../imagenes/informamos.jpg',      -->
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {

  },
  computed:{
    estadoFechaE(){
      return this.FechaElegida != '' ? true : false
    },
    estadoPersona(){
      return this.persona.length!=1 ? true : false
    },
    encontroPersona(){
      return this.persona.length==1 ? true : false
    },    
    siEsViernes(){
      return new Date(this.FechaElegida).getDay()==4 || new Date(this.FechaElegida).getDay()==3 || new Date(this.FechaElegida).getDay()==2 || new Date(this.FechaElegida).getDay()==1 || new Date(this.FechaElegida).getDay()==0 ? false : true
    },
    siNoEsViernes(){
      return  new Date(this.FechaElegida).getDay()==5 ? false : true
    },
    nombrePersona(){
      return this.persona.length==1 ? this.persona[0].nombre : ''
    },
    validarTelefono(){
      return this.Telefono.length>9 ? true : false
    },
    validarMail(){
      return this.Mail.length>4  ? true : false
    },
    validarHorario(){
      return this.HorarioElegido>4  ? true : false
    },
    validarReservaTurno(){
      return this.validarTelefono && this.validarMail && this.validarHorario && this.nombrePersona ? false : true
    },
    validarapyno1(){
      return this.apyno1.length>10 ? true : false
    },
    validarTelefono1(){
      return this.Telefono1.length>9 ? true : false
    },      
    validarMail1(){
      return this.Mail1.length>4  ? true : false
    },
    validarDNI1(){
      return this.DNI1.length>5  ? true : false
    },
    validarHorario1(){
      return this.validarapyno1 && this.validarTelefono1 && this.validarMail1 && this.validarDNI1 ? false : true
    },
    validarReservaTurno1(){
      return this.HorarioElegido>4 && this.validarapyno1 ? false : true
    }
  },  
  methods:{

    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()
      const day = date.getDate()
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6 //|| day === 20
    },

    reservarTurno1: async function (){
      try{
        let newPost={
          opcion:"GuardarTurno",
          id_reg:this.HorarioElegido,
          apyno:this.apyno1,
          dni:this.DNI1,
          mail:this.Mail1,
          telefono:this.Telefono1,
        };
        const entradasBD = await fetch('http://www.hcdrauch.com.ar/turnosInspeccion/cargar_turnos.php',{
            method:'POST',
            body: JSON.stringify(newPost),
            headers:{
              "Content-Type": "application/json"
            }
        });

        
        this.mensaje= await entradasBD.json();
        console.log(this.mensaje[0].confirmado);
        if (this.mensaje[0].confirmado=='No'){
          this.$refs['my-modal'].show();
        }

        this.apyno1='';
        this.FechaElegida='';
        this.HorarioElegido='';
      }catch (error){
        console.log(error);
        this.$refs['my-modal-no'].show();
      }        
    },

    reservarTurno: async function (){
      try{
        let newPost={
          opcion:"GuardarTurno",
          id_reg:this.HorarioElegido,
          apyno:this.persona[0].nombre,
          dni:this.persona[0].documento,
          mail:this.Mail,
          telefono:this.Telefono,
        };
        const entradasBD = await fetch('http://www.hcdrauch.com.ar/turnosInspeccion/cargar_turnos.php',{
            method:'POST',
            body: JSON.stringify(newPost),
            headers:{
              "Content-Type": "application/json"
            }
        });
        this.$refs['my-modal'].show();
        this.mensaje= await entradasBD;
        this.persona=[];
        this.FechaElegida='';
        this.HorarioElegido='';
        
      }catch (error){
        console.log(error);
      }        
    },

    buscarPorNumero: async function (){
      try{
        let newPost={
          opcion:"BuscarPorNumero",
          dni:this.DNI           
        };
     
        const entradasBD = await fetch('http://www.hcdrauch.com.ar/turnosInspeccion/cargar_turnos.php',{
            method:'POST',
            body: JSON.stringify(newPost),
            headers:{
              "Content-Type": "application/json"
            }
        });
        this.persona = await entradasBD.json();
      }catch (error){
        console.log(error);
      }        
    },

    Cargar_tabla_turnos: async function (){
      this.HorarioElegido='';
      this.persona=[];
      this.apyno1='';

      try{
        let newPost={
          opcion:"Turnos",
          area:6,
          fecha:this.FechaElegida,            
        };
        console.log(newPost);
        const entradasBD = await fetch('http://www.hcdrauch.com.ar/turnosInspeccion/cargar_turnos.php',{
            method:'POST',
            body: JSON.stringify(newPost),
            headers:{
              "Content-Type": "application/json"
            }
        });
        this.array_turnos = await entradasBD.json();
      }catch (error){
        console.log(error);
      }  
    }
  },
  data() {
    return {
      FechaElegida:'',
      HorarioElegido:'',
      f_salida:'',
      array_turnos:[],
      apyno:'',
      apyno1:'',
      DNI:'',
      DNI1:'',
      persona:[],
      Telefono:'',
      Telefono1:'',
      Mail:'',
      Mail1:'',
      mensaje:'',
    }
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
label {
  margin-top: 10px;

}
</style>
